<main>
    <div class="bolt-container">
        <div class="bolt-space-bottom-md"></div>
        <bolt-breadcrumbs
            class="bolt-space-bottom-4xl"
            currentleveltext="{{currentPage}}"
            iconlink="{{homeIconLink}}">
            <li *ngFor="let bc of breadCrumbs">
                <a [routerLink]="bc.link">{{bc.name}}</a>
            </li>
        </bolt-breadcrumbs>
        <bolt-notification class="bolt-space-bottom-md"
            type="info"
            *ngIf="isUnregisteredUser">
            This is a quick view of the claim. <a class="bolt-link"
                href="{{environment.NATIONWIDE.MY_ACCOUNT_LOGIN}}"
                rel="noopener">Log in</a> to see everything about it, including estimates, payments, documents, and photos.
        </bolt-notification>
        <bolt-waiting-indicator class="bolt-space-inner-xl" *ngIf="isLoadingOverview"></bolt-waiting-indicator>
        <bolt-notification *ngIf="claimOverviewError">Your claim overview didn't load. We'll get it fixed.</bolt-notification>
        <div *ngIf="!isLoadingOverview" class="bolt-row bolt-space-bottom-2xl bolt-justify-content-between">
            <div class="bolt-col-md-8 bolt-col-lg-9 bolt-col-12">
                <h1 class="bolt-heading-xl bolt-space-left-2xs bolt-heading-vibrantBlue">Claim overview</h1>
                <div class="bolt-row bolt-space-left-2xs">
                    <bolt-icon aria-hidden="true" name="home"></bolt-icon>
                    <div class="bolt-subheading-lg bolt-col-10 bolt-space-bottom-sm">
                        <strong>{{lossLocation}}</strong>
                    </div>
                </div>
                <div class="bolt-row bolt-space-bottom-md">
                    <div class="bolt-col-lg-5 bolt-col-md-4 bolt-col-12 bolt-space-left-4xl">
                        <div class="bolt-body-copy-md bolt-space-bottom-2xs">Claim number: {{claimNumber}}</div>
                        <div class="bolt-body-copy-md bolt-space-bottom-2xs">Claim status:
                            <bolt-tag label="{{claimStatus === 'open' ? 'Open' : 'Closed'}}" color="{{claimStatus === 'open' ? 'mediumBlue' : ''}}" status="{{claimStatus === 'open' ? '' : 'success'}}"></bolt-tag>
                        </div>
                    </div>
                    <div class="bolt-col-lg-5 bolt-col-md-4 bolt-col-12 bolt-space-left-4xl">
                        <div class="bolt-body-copy-md bolt-space-bottom-2xs">Incident date: {{incidentDate | date:'MMMM d, y'}}</div>
                        <div class="bolt-body-copy-md bolt-space-bottom-2xs">Type of claim: {{lossCause}}</div>
                    </div>
                </div>
            </div>
            <div class="bolt-col-12 bolt-col-md-auto">
                <bolt-button width="full-md" iconleft="send" (click)="openTellUsMore()">Tell us more</bolt-button>
            </div>
        </div>
        <div id="tellUsMoreModal">
            <is-tell-us-more-modal></is-tell-us-more-modal>
        </div>
    </div>
    <div class="bolt-space-bottom-4xl" >
        <is-timeline id="timeline" [claimNumber]="claimNumber" [useCaching]="true" [contactPublicId]="contactPublicId" (goToTab)="changeTab($event)" (hideContractor)="hideContractor($event)" (showTimeline) = "showTimeline($event)" (setPaymentsNotApplicable)="setPaymentsNotApplicable($event)" (loadTimeEmitter)="onComponentLoadTime($event)"></is-timeline>
    </div>
    <div class="mobile-only tile-stack bolt-space-bottom-sm">
        <bolt-tile (click)="onTileClick($event)" href="javascript:void(0)" label="Updates"></bolt-tile>
        <bolt-tile (click)="onTileClick($event)" href="javascript:void(0)" label="Documents"></bolt-tile>
        <bolt-tile (click)="onTileClick($event)" href="javascript:void(0)" label="Coverages"></bolt-tile>
        <bolt-tile *ngIf="!isHideContractor" (click)="onTileClick($event)" href="javascript:void(0)" label="Contractors"></bolt-tile>
        <bolt-tile (click)="onTileClick($event)" href="javascript:void(0)" label="Payments"></bolt-tile>
        <bolt-tile (click)="onTileClick($event)" href="javascript:void(0)" label="Support"></bolt-tile>
    </div>
    <bolt-tabset #tabset *ngIf="isTimelineVisible" class="desktop-only" borderless (bolt-tab-changed)="onTabChange($event)" [activetab]="selectedTabIndex">
        <bolt-tablabel>Updates</bolt-tablabel>
        <bolt-tabpanel>
            <is-claim-updates *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber" (loadTimeEmitter)="onComponentLoadTime($event)"></is-claim-updates>
        </bolt-tabpanel>
        <bolt-tablabel>Documents</bolt-tablabel>
        <bolt-tabpanel>
            <is-documents *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber" [displayUnregistered]="isUnregisteredUser"></is-documents>
        </bolt-tabpanel>
        <bolt-tablabel>Coverages</bolt-tablabel>
        <bolt-tabpanel>
            <is-coverages *ngIf="claimNumber" [useCaching]="true" [incidentDate]="incidentDate"  [claimNumber]="claimNumber" [displayUnregistered]="isUnregisteredUser" (goToTab)="changeTab($event)"></is-coverages>
        </bolt-tabpanel>
        <bolt-tablabel *ngIf="!isHideContractor">Contractors</bolt-tablabel>
        <bolt-tabpanel *ngIf="!isHideContractor">
            <is-contractors *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber"></is-contractors>
        </bolt-tabpanel>
        <bolt-tablabel>Payments</bolt-tablabel>
        <bolt-tabpanel>
            <is-payments *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber" [contactPublicId]="contactPublicId" [isPaymentsNotApplicable]="isPaymentsNotApplicable" [displayUnregistered]="isUnregisteredUser"></is-payments>
        </bolt-tabpanel>
        <bolt-tablabel>Support</bolt-tablabel>
        <bolt-tabpanel>
            <is-support *ngIf="claimNumber" [useCaching]="true" [claimNumber]="claimNumber"></is-support>
        </bolt-tabpanel>
    </bolt-tabset>
</main>
